import React, { Component, Fragment } from "react";
import { ExcelRenderer } from "react-excel-renderer";
import { connect } from "react-redux";
import BacktestService from "../../../service/backtest.service";
import UploadFileButton from "../../common/buttons/uploadFileButton";
import Spinner from "../../common/spinner";
import "./SelectType.styles.scss";
import Helper from "./universe_lite/helper/Helper";
// import Backtest from "../../../service/backtest.service";

class SelectType extends Component {
  _isMounted = false;
  state = {
    // selected_id_index: 0,
    // templateData: [],
    clickedUploadButton: false,
    inValidExcelData: false,
    listOfID: [],
    listOfPortfolioNames: [],
    concatedData: {},
    TempData: {},
    securityUniverseInvalidData: false,
    securityErrorColumnName: "",
    AnalyzePortfolioError: false,
    AnalyzeErrorColumnName: "",
    loading: false,
    my_universe: true,
  };

  async componentWillMount() {
    this._isMounted = true;
    if (this.props.myUniverse && this.props.myUniverse.length === 0) {
      this.setState({
        loading: true,
      });
      await BacktestService.getMyUniverse()
        .then((res) => {
          if (res && this._isMounted) {
            this.props.setIQCIOliveMyUniverse(res);
            this.setState({
              loading: false,
            });
          }
        })
        .catch((err) => {
          this.setState({
            loading: false,
          });
          console.log(err);
        });
    }
    let _user_preferences = window.localStorage._user_preferences
      ? JSON.parse(window.localStorage._user_preferences)
      : false;

    if (_user_preferences) {
      let my_univ = _user_preferences["my_universe"];
      if (process.env.NODE_ENV !== "production") my_univ = true;

      this.setState({
        my_universe: my_univ,
      });
    }
  }
  async componentDidMount() {
    this._isMounted = true;
    const {
      modelportfolios,
      setSecurityUniverseLite,
      setAnalyzeUniverseLite,
      setAllocatioError,
      setLitePortfolioActive,
      setActiveGoal,
      setPortfolioID,
      setBenchmarkName,
      setModelPortfolios,
      list_of_myPortfolios,
      setMyPortfolios,
      myClientAnalysePortfolio,
    } = this.props;

    //reset
    this.props.setSecuritiesValidToNextStep(true);
    this.props.resetUniverseLitePreDefinedModel();
    this.props.setHistoricalReturns([]);
    this.props.setActiveOptimizeUsingMyUniverse(false);
    this.props.resetPortfolioName("");
    this.props.resetComparePortfolioAnalyzeID(0);
    this.props.resetOrigPortfolioDisplay(false);
    this.props.resetAnalyzeMergedData([]);
    this.props.resetAbsoluteTunersSwitch();
    this.props.resetManualSecurity();
    setSecurityUniverseLite(false);
    setAnalyzeUniverseLite(false);
    setAllocatioError(false);

    //-----------
    setLitePortfolioActive(false);
    if (modelportfolios.length) {
      var listOfID = [],
        listOfPortfolioNames = [];
      var data = modelportfolios.map((e) => {
        listOfPortfolioNames.push(e["data"][0]["benchmark"]);
        listOfID.push(e["data"][0].scenario_id);
      });

      this.setState({
        listOfID,
        listOfPortfolioNames,
      });
      // let specializedPortfoio = modelportfolios.filter(
      //   (e) => e.name == "Specialized"
      // );

      // if (specializedPortfoio) {
      //   let id = specializedPortfoio[0]["data"][0]["scenario_id"];
      //   BacktestService.getScenarioShortlist(`${id}`).then((data) =>
      //     console.log(data)
      //   );
      // }

      // setting default id and model data
      setModelPortfolios(modelportfolios);
      setActiveGoal(modelportfolios[0]);
      setPortfolioID(modelportfolios[0].data[0].scenario_id);
      setBenchmarkName(modelportfolios[0].data[0].benchmark_name);
      //--------
    }

    // making api call to myPortfolios if its empty

    if (list_of_myPortfolios && list_of_myPortfolios.length == 0) {
      let live, Backtest;
      await BacktestService.getScenariosNew("LIVE").then((res) => {
        if (res && this._isMounted) {
          live = res;
        }
      });
      await BacktestService.getScenariosNew("BACKTEST").then((res) => {
        if (res && this._isMounted) {
          Backtest = res;
        }
      });
      if (live && Backtest) {
        let merged_data = live.concat(Backtest);
        setMyPortfolios(merged_data);
      }
    }

    // triggering analyze an existing portfolio step
    // if selecting analysis from MyClients > ANALYSE PORTFOLIO
    if (myClientAnalysePortfolio) {
      this.analize_Handler();
    }
  }
  async componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.modelportfolios.length !== this.props.modelportfolios.length
    ) {
      this._isMounted = true;
      const { modelportfolios } = this.props;

      let listOfID = [],
        listOfPortfolioNames = [];

      modelportfolios.map((e) => {
        listOfPortfolioNames.push(e["data"][0]["benchmark"]);
        listOfID.push(e["data"][0].scenario_id);
      });

      this.setState({
        listOfID,
        listOfPortfolioNames,
      });

      let scenario_shortlist_data = {};

      if (
        listOfID.length &&
        prevProps.concatedScenarioShortlist &&
        Object.keys(prevProps.concatedScenarioShortlist).length === 0
      ) {
        for (let i = 0; i < listOfID.length; i++) {
          // var concatData = Object.assign({}, this.state.TempData);
          await BacktestService.getScenarioShortlist(`${listOfID[i]}`).then(
            (data) => {
              if (data) {
                // let obj = (concatData[`${listOfID[i]}`] = data);
                scenario_shortlist_data[listOfID[i]] = data;
                // this.setState({
                //   TempData: obj,
                //   concatedData: concatData,
                // });
              }
            }
          );
        }
      }
      await this.props.setScenarioShortlist(scenario_shortlist_data);
    }
  }
  componentWillUnmount() {
    this._isMounted = false;
  }

  xlsxEvent = (event, selected_ScenarioID, type) => {
    this.setState({
      clickedUploadButton: true,
    });

    const {
      setUniverseLitePortfolio,
      setLitePortfolioActive,
      modelportfolios,
      setActiveGoal,
      setBenchmarkName,
      lite_symbols,
      nextStepCallBack,
      setPortfolioID,
      setBenchmarkLite,
      setSecurityUniverseLite,
      setSecuritiesValidToNextStep,
      setIQCIOliveMyUniverse,
      setIQCIOliveMyUniverseUpload,
      UploadedUniverse,
      MyUniverse,
    } = this.props;

    var file = event.target.files[0];

    if (file) {
      ExcelRenderer(file, (err, res) => {
        if (err) {
          console.log("Error Converting Excel File to JSON", err);
        } else {
          var response = res["rows"];

          // checks if any null or empty data and removes it
          let resData = response.filter(
            (d) => d.length && d[0] && d[1] && d[2] && d[3] && d[4]
          );
          if (resData.length === 0) return;
          let filtered = resData.map((d) => {
            return d.filter((el) => el != null);
          });

          var filteredData = filtered.filter((d) => d.length);

          var heading = filteredData[0].map((e) => e.toLowerCase());

          var data = resData.slice(1, filteredData.length);

          const getIndex = (data, string) => {
            return data.indexOf(string);
          };

          let security_index = getIndex(heading, "security");
          let symbol_index = getIndex(heading, "symbol");
          let fund_type_index = getIndex(heading, "fund type");
          let classification_index = getIndex(heading, "classification");
          let asset_class_index = getIndex(heading, "asset class");
          let style_index = getIndex(heading, "style");
          let core_allocation_index = getIndex(heading, "allocation");

          // getting which column has error
          const getStatus = () => {
            if (security_index === -1) {
              setValue("security");
              return;
            } else if (symbol_index === -1) {
              setValue("symbol");
              return;
            } else if (fund_type_index === -1) {
              setValue("fund type");
              return;
            } else if (classification_index === -1) {
              setValue("classification");
              return;
            } else if (asset_class_index === -1) {
              setValue("asset class");
              return;
            } else if (style_index === -1) {
              setValue("style");
              return;
            } else if (core_allocation_index === -1) {
              if (type === "analyze") {
                setValue("allocation");
              }
              return;
            }
          };
          const setValue = (name) => {
            if (type === "security_universe") {
              this.setState({
                securityErrorColumnName: name,
              });
            } else if (type === "analyze") {
              this.setState({
                AnalyzeErrorColumnName: name,
              });
            }
          };

          getStatus();

          let condition;

          if (type === "security_universe") {
            condition =
              (heading[security_index] === "security" ||
                security_index !== -1) &&
              (heading[symbol_index] == "symbol" || symbol_index !== -1);
          } else {
            condition =
              ((heading[security_index] === "security" ||
                security_index !== -1) &&
                (heading[symbol_index] === "symbol" || symbol_index !== -1) &&
                (heading[fund_type_index] === "fund type" ||
                  fund_type_index !== -1) &&
                (heading[classification_index] === "classification" ||
                  classification_index !== -1) &&
                (heading[asset_class_index] === "asset class" ||
                  asset_class_index !== -1) &&
                (heading[style_index] === "style" || style_index !== -1) &&
                heading[core_allocation_index] === "allocation") ||
              core_allocation_index !== -1;
          }

          if (heading.length > 0 && condition) {
            let arr = [];
            for (let i = 0; i < data.length; i++) {
              let obj = {};
              obj.fund_name = data[i][security_index];
              obj.symbol = data[i][symbol_index];
              obj.new_fund_type = data[i][fund_type_index];
              obj.new_classification = data[i][classification_index];
              obj.fund_asset_class_focus = data[i][asset_class_index];
              obj.new_style = data[i][style_index];
              obj.initial_allocation =
                data[i][core_allocation_index] && type === "analyze"
                  ? data[i][core_allocation_index]
                  : null;
              obj.val =
                data[i][core_allocation_index] && type === "analyze"
                  ? data[i][core_allocation_index]
                  : null;
              obj.action = "keep";
              obj.addedRow = false;
              arr.push(obj);
            }

            // setLitePortfolioActive(true);
            // adding default key value pair to bse 500 data
            var lite_symbols_default = lite_symbols.map((el) => {
              var o = Object.assign({}, el);
              o.action = "keep";
              o.initial_allocation = null;
              o.addedRow = false;
              return o;
            });

            const mergeArrayOfOBJ = (arrays, name) => {
              var merged = {};

              arrays.forEach((arr) => {
                arr.forEach((item) => {
                  merged[item[name]] = Object.assign(
                    {},
                    merged[item[name]],
                    item
                  );
                });
              });
              return Object.values(merged);
            };

            //  setting default cash row
            let cashFind = arr.filter(
              (d) => d.fund_name.toLowerCase() === "cash"
            );

            if (cashFind.length === 0) {
              let obj = {
                action: "keep",
                fund_asset_class_focus: "Cash",
                fund_name: "Cash",
                initial_allocation: 0,
                new_classification: "Cash",
                new_style: "Cash",
                symbol: "IQCASH",
                val: 0,
              };
              let ar = [obj, ...arr];
              setUniverseLitePortfolio(ar);
              setIQCIOliveMyUniverseUpload(ar);
            } else {
              setUniverseLitePortfolio(arr);
              setIQCIOliveMyUniverseUpload(arr);
            }

            if (type === "security_universe") {
              setSecurityUniverseLite(true);
            }
            setSecuritiesValidToNextStep(true);
            setLitePortfolioActive(true);
            setActiveGoal(modelportfolios[selected_ScenarioID]);
            setPortfolioID(
              modelportfolios[selected_ScenarioID].data[0].scenario_id
            );
            setBenchmarkName(
              modelportfolios[selected_ScenarioID].data[0].benchmark_name
            );
            setBenchmarkLite(
              modelportfolios[selected_ScenarioID].data[0].benchmark
            );

            //setting max_limit to max value from uploaded securities
            //if its analyze-an existing-portfolio
            if (type === "analyze") {
              let ID = modelportfolios[selected_ScenarioID].data[0].scenario_id;
              //getting max value
              let value;
              value = arr.map((e) => e.val).reduce((a, b) => Math.max(a, b));

              if (value === 0) {
                value = 10;
              }

              this.props.changeUIParams(
                ["optimization_params", "upper_bounds"],
                +value,
                +ID
              );

              this.setState({
                AnalyzePortfolioError: false,
              });
            }

            if (type === "security_universe") {
              let data;
              let ID = modelportfolios[selected_ScenarioID].data[0].scenario_id;
              let upperBound =
                this.props.optimization_params[ID]["upper_bounds"] * 1;
              data = Helper.getLimitsDataFromSymbols(arr, upperBound);
              this.props.setBackendParam_Security_Universe_limits(data);

              this.setState({
                securityUniverseInvalidData: false,
              });
            }
            nextStepCallBack(true, 1);
          } else {
            document.getElementById("upload_scenario_file1").value = "";
            // document.getElementById("upload_scenario_file2").value = "";
            // invalid excel data
            console.log("invalid excel data");
            this.setState({
              inValidExcelData: true,
              clickedUploadButton: false,
            });

            if (type === "security_universe") {
              this.setState({
                securityUniverseInvalidData: true,
              });
            } else if (type === "analyze") {
              this.setState({
                AnalyzePortfolioError: true,
              });
            }
          }
        }
      });
    }
  };

  curated_securities_handler = (e) => {
    this.props.setLitePortfolioActive(false);
    this.props.nextStepCallBack(true);

    this.props.setSecuritiesValidToNextStep(false);
    // this.props.setSymbols([]);
    // this.props.setInitialTableData([]);
  };
  startWithOwnUniverse = async () => {
    const {
      setSecurityUniverseLite,
      setSecuritiesValidToNextStep,
      setLitePortfolioActive,
      setActiveGoal,
      setPortfolioID,
      setBenchmarkName,
      setBenchmarkLite,
      modelportfolios,
      setUniverseLitePortfolio,
      nextStepCallBack,
      myUniverse,
      UploadedUniverse,
      setIQCIOliveMyUniverseUpload,
    } = this.props;

    let modify = ({ data }) => {
      let arr = [];
      for (let i = 0; i < data.length; i++) {
        let obj = {};
        obj.fund_name = data[i]["fund_name"];
        obj.symbol = data[i]["symbol"];
        obj.new_fund_type = data[i]["fund_type"];
        obj.new_classification = data[i]["classification"];
        obj.fund_asset_class_focus = data[i]["asset_class"];
        obj.new_style = data[i]["style"];
        obj.initial_allocation = null;
        obj.val = data[i]["val"];
        obj.action = "keep";
        obj.addedRow = false;
        arr.push(obj);
      }

      return arr;
    };

    let data = modify({ data: myUniverse });
    //------------------

    let d;
    let ID =
      modelportfolios &&
      modelportfolios[0] &&
      modelportfolios[0].data[0] &&
      modelportfolios[0].data[0].scenario_id;
    let upperBound = this.props.optimization_params[ID]["upper_bounds"] * 1;
    d = Helper.getLimitsDataFromSymbols(data, upperBound);

    this.setState({
      securityUniverseInvalidData: false,
    });

    //------------------

    setSecurityUniverseLite(true);
    setSecuritiesValidToNextStep(true);
    setLitePortfolioActive(true);
    setActiveGoal(modelportfolios[0]);
    setPortfolioID(modelportfolios[0].data[0].scenario_id);
    setBenchmarkName(modelportfolios[0].data[0].benchmark_name);
    setBenchmarkLite(modelportfolios[0].data[0].benchmark);

    setUniverseLitePortfolio(data);
    this.props.setBackendParam_Security_Universe_limits(d);
    nextStepCallBack(true, 1);
    setIQCIOliveMyUniverseUpload({});
  };

  analize_Handler = () => {
    const {
      setActiveGoal,
      setPortfolioID,
      setBenchmarkName,
      setBenchmarkLite,
      modelportfolios,
      setUniverseLitePortfolio,
      setLitePortfolioActive,
      nextStepCallBack,
      setAnalyzeUniverseLite,
      setHistoricalReturns,
    } = this.props;
    let defaultPortfolio = 0;
    setHistoricalReturns([]);
    setLitePortfolioActive(true);
    setAnalyzeUniverseLite(true);
    nextStepCallBack(true, 1);
    if (modelportfolios.length) {
      setActiveGoal(modelportfolios[defaultPortfolio]);
      setPortfolioID(modelportfolios[defaultPortfolio].data[0].scenario_id);
      setBenchmarkName(
        modelportfolios[defaultPortfolio].data[0].benchmark_name
      );
      setBenchmarkLite(modelportfolios[defaultPortfolio].data[0].benchmark);
      //clearing universe lite portfolios
      setUniverseLitePortfolio([]);
    }
  };
  Error = (name) => {
    return (
      <div className="select_type_error">
        <p className="dataWarning">
          {`${name.toUpperCase()} column missing. Please make sure "${name}"
              column exists in the uploaded portfolio excel. `}
        </p>
      </div>
    );
  };

  render() {
    const {
      listOfID,
      listOfPortfolioNames,
      securityUniverseInvalidData,
      securityErrorColumnName,
      AnalyzePortfolioError,
      AnalyzeErrorColumnName,
      loading,
      my_universe,
    } = this.state;
    const { concatedScenarioShortlist } = this.props;
    return (
      <div className="select_type">
        {my_universe && (
          <SelectTypeCard>
            <div className="select_type_heading">
              <img src="/images/select_type_1.png" alt="IQCio" />
              <h4>START WITH YOUR OWN SECURITY UNIVERSE</h4>
            </div>
            <div className="select_type_content">
              <p>
                If you have a pre defined list of securities that you would like
                to use for constructing a new portfolio, please upload the same
                as the security universe to the portfolio creation process.
              </p>
              <p>
                Please note that the uploaded excel sheet must contain the 3
                columns : <b>exchange, security &amp; symbol</b>
              </p>
            </div>
            {securityUniverseInvalidData
              ? this.Error(securityErrorColumnName)
              : null}
            {loading ? (
              <Spinner />
            ) : (
              <div className="select_type_button_holder">
                <div
                  style={{ display: "flex", justifyContent: "space-evenly" }}
                >
                  <button
                    className="btn text-uppercase"
                    onClick={this.startWithOwnUniverse}
                  >
                    Start with My Universe
                  </button>
                  <UploadFileButton
                    text="Upload New Universe"
                    className="btn"
                    onHoverStyle={true}
                    eventHandler={(e) =>
                      // this.xlsxEvent(e, selected_id_index, "security_universe")
                      this.xlsxEvent(e, 0, "security_universe")
                    }
                    id="upload_scenario_file1"
                  />
                </div>
              </div>
            )}
          </SelectTypeCard>
        )}
        <SelectTypeCard>
          <div className="select_type_heading">
            <img src="/images/select_type_2.png" alt="IQCio" />
            <h4>ANALYZE AN EXISTING PORTFOLIO</h4>
          </div>
          <div className="select_type_content">
            <p>
              If you would like us to analyze your existing portfolio, please
              upload the same in excel format. Please make sure the portfolio
              xls you are uploading contains the 3 columns : security, symbol
              &amp; allocation.
            </p>
            <p>
              Alternately you can download one of the templates based on a
              benchmark lists, fill the allocations and upload the same.
            </p>
          </div>
          {AnalyzePortfolioError ? this.Error(AnalyzeErrorColumnName) : null}
          <div className="select_type_button_holder">
            <div className="select_type_button_holder_single">
              <button
                className="btn text-uppercase"
                onClick={() => this.analize_Handler()}
              >
                START WITH THIS OPTION
              </button>
            </div>
          </div>
        </SelectTypeCard>
        <SelectTypeCard>
          <div className="select_type_heading">
            <img src="/images/select_type_3.png" alt="IQCio" />
            <h4>START WITH IQCIO CURATED SECURITIES</h4>
          </div>
          <div className="select_type_content">
            <p>
              We at IQCIO have a curated list of securities that you could start
              off with for the portfolio creation process. You will be able to
              select one of the pre defined security universe in the next step.
            </p>
            <p>
              Once you start with the IQCiO curated list, you will be provided
              an option to add additional securities of your own or remove ones
              from the list, in the subsequent steps
            </p>
          </div>
          <div className="select_type_button_holder">
            <div className="select_type_button_holder_single">
              <button
                className="btn text-uppercase"
                onClick={(e) => this.curated_securities_handler(e)}
              >
                {" "}
                Start with this option
              </button>
            </div>
          </div>
        </SelectTypeCard>
        {/*
        {this.state.templateData.length ? (
          <Table id="template_table" data={this.state.templateData} />
        ) : null} */}

        {concatedScenarioShortlist &&
        Object.keys(concatedScenarioShortlist).length > 0 ? (
          <Fragment>
            {Object.keys(concatedScenarioShortlist).map((key, i) => {
              return (
                <Table
                  id={`template_table_${key}`}
                  data={concatedScenarioShortlist[key]}
                  key={i}
                />
              );
            })}
          </Fragment>
        ) : null}
      </div>
    );
  }
}

const SelectTypeCard = ({ children }) => {
  return <div className="select_type_card">{children}</div>;
};

const Table = ({ id, data }) => {
  return (
    <table id={id} style={{ display: "none" }}>
      <thead>
        <tr>
          <th>Security</th>
          <th>Symbol</th>
          <th>Fund Type</th>
          <th>Classification</th>
          <th>Asset Class</th>
          <th>Style</th>
          {/* <th>Allocation</th> */}
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Cash</td>
          <td>IQCASH</td>
          <td>Cash</td>
          <td>Cash</td>
          <td>Cash</td>
          {/* <td></td> */}
        </tr>
        {data &&
          data.length > 0 &&
          data.map((item, i) => (
            <tr key={i}>
              <td>{item.fund_name}</td>
              <td>{item.symbol}</td>
              <td>{item.new_fund_type}</td>
              <td>{item.new_classification}</td>
              <td>{item.fund_asset_class_focus}</td>
              <td>{item.new_style}</td>
              {/* <td>{item.val}</td> */}
            </tr>
          ))}
      </tbody>
    </table>
  );
};

export default connect(
  ({
    create: {
      modelportfolios,
      concatedScenarioShortlist,
      steps: {
        universeLite: { lite_symbols },
        backendParams: { optimization_params },
      },
    },
    iqciolive: { myUniverse, UploadedUniverse },
    myPortfolios: { list_of_myPortfolios },
    myClients: { myClientAnalysePortfolio },
  }) => ({
    modelportfolios,
    concatedScenarioShortlist,
    lite_symbols,
    optimization_params,
    myUniverse,
    UploadedUniverse,
    list_of_myPortfolios,
    myClientAnalysePortfolio,
  }),
  (dispatch) => ({
    setPortfolioID: (payload) =>
      dispatch({ type: "SET_PORTFOLIO_ID", payload }),
    setActiveGoal: (inv) => dispatch({ type: "SET_ACTIVE_GOAL", payload: inv }),
    setUniverseLitePortfolio: (payload) =>
      dispatch({ type: "SET_UNIVERSE_LITE_PORTFOLIO", payload }),
    setLitePortfolioActive: (payload) =>
      dispatch({ type: "SET_UNIVERSE_LITE_ACTIVE", payload }),
    setIQCIOliveMyUniverseUpload: (payload) =>
      dispatch({ type: "SET_IQCIO_LIVE_MY_UNIVERSE_UPLOADED", payload }),
    setBenchmarkName: (payload) =>
      dispatch({ type: "SET_BENCHMARKNAME", payload }),
    // initial table data and cloned table data of step2 clearing
    setSymbols: (payload) => dispatch({ type: "SET_UNIVERSE_DATA", payload }),
    setInitialTableData: (payload) =>
      dispatch({ type: "SET_INITIAL_TABLE_DATA", payload }),
    setSecuritiesValidToNextStep: (payload) =>
      dispatch({ type: "SET_UNIVERSE_SECURITYVALIDITY", payload }),
    setBenchmarkLite: (val) =>
      dispatch({ type: "SET_BENCHMARK_LITE", payload: val }),
    setSecurityUniverseLite: (payload) =>
      dispatch({ type: "SET_SECURITY_UNIVERSE_LITE", payload: payload }),
    setAnalyzeUniverseLite: (payload) =>
      dispatch({ type: "SET_ANALYZE_UNIVERSE_LITE", payload: payload }),
    changeUIParams: (ui_ixs, ui_value, id) =>
      dispatch({ type: "CHANGE_UI_PARAMS", payload: { ui_ixs, ui_value, id } }),
    setBackendParam_Security_Universe_limits: (payload) =>
      dispatch({
        type: "SET_BACKENDPARAMS_SECURITY_UNIVERSE_LIMITS_DATA",
        payload,
      }),
    resetManualSecurity: () =>
      dispatch({ type: "RESET_MANUALLY_ADDED_SECURITIES" }),
    setAllocatioError: (value) =>
      dispatch({
        type: "ALLOCATION_SUM_ERROR",
        payload: value,
      }),
    setHistoricalReturns: (payload) =>
      dispatch({
        type: "SET_UNIVERSE_LITE_HISTORICAL_RETURNS",
        payload,
      }),
    setActiveOptimizeUsingMyUniverse: (payload) =>
      dispatch({
        type: "SET_ACTIVE_OPTIMIZE_USING_MYUNIVERSE",
        payload,
      }),
    resetComparePortfolioAnalyzeID: (payload) =>
      dispatch({ type: "SET_COMPARE_PORTFOLIO_ID_ANALYZE", payload }),
    resetPortfolioName: (value) =>
      dispatch({ type: "SET_PORTFOLIO_NAME", payload: value }),

    resetOrigPortfolioDisplay: (payload) =>
      dispatch({
        type: "SET_ORIG_PORTFOLIO_DISPLAY",
        payload,
      }),
    setIQCIOliveMyUniverse: (payload) =>
      dispatch({
        type: "SET_IQCIO_LIVE_MY_UNIVERSE",
        payload,
      }),
    setModelPortfolios: (modelportfolios) =>
      dispatch({ type: "SET_PORTFOLIOS", payload: modelportfolios }),
    setScenarioShortlist: (payload) =>
      dispatch({
        type: "SET_TABLE_CONCATED_SCENARIOSHORTLIST",
        payload,
      }),
    setMyPortfolios: (payload) =>
      dispatch({
        type: "SET_LIST_OF_MYPORTFOLIOS",
        payload,
      }),
    resetUniverseLitePreDefinedModel: (payload) =>
      dispatch({
        type: "RESET_SET_UNIVERSE_LITE_PRE_DEFINED_MODEL",
        payload,
      }),
    resetAnalyzeMergedData: (payload) =>
      dispatch({
        type: "SET_ANALYZE_MERGED_PORTFOLIOS",
        payload,
      }),
    resetAbsoluteTunersSwitch: () => {
      dispatch({
        type: "CREATE_STEP_ABSOLUTE_SWITCH_HANDLER",
        payload: {
          name: "",
          value: false,
        },
      });
    },
  })
)(SelectType);



// WEBPACK FOOTER //
// ./src/components/pages/Create/SelectType.jsx